import {Component, HostListener, Inject, NgZone, OnDestroy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {SettingsService} from "../../service/settings.service";
import {LayoutService} from "../../service/layout.service";
import {Router} from "@angular/router";
import {SidenavService} from "../../service/sidenav.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {HymnSelectionService} from "../../service/hymn-selection.service";
import {BackButtonService} from "../../service/back-button.service";
import {translation} from "../../translation";

@Component({
  selector: 'app-dialpad',
  standalone: true,
  imports: [MatIconModule, MatButtonModule, MatDialogModule],
  templateUrl: './dialpad.component.html',
  styleUrl: './dialpad.component.scss'
})
export class DialpadComponent implements OnDestroy {
  hymnNumber = '000';

  constructor(
    public dialogRef: MatDialogRef<DialpadComponent>,
    private zone: NgZone,
    private layoutService: LayoutService,
    private settingService: SettingsService,
    private sidenavService: SidenavService,
    private router: Router,
    private snackBar: MatSnackBar,
    private hymnSelectionService: HymnSelectionService,
    private backButtonService: BackButtonService) {}

  ngOnDestroy(): void {
    this.hymnSelectionService.dialpadActive = false;
  }

  ngOnInit(): void {
    this.hymnSelectionService.dialpadActive = true;
    this.backButtonService.registerBackButtonAction(() => {
      this.dialogRef.close();
    })
  }

  onCancel(): void {
    if (this.hymnNumber !== '000') {
      this.hymnNumber = '000';
    }
    else {
      this.dialogRef.close();
    }
  }

  onHymn() {
    if (this.hymnNumber !== '000') {
      const hymnToView = Number(this.hymnNumber);
      if (hymnToView <= translation.hymn_count) {
        this.zone.run(() => {
          this.router.navigate(['/' + this.settingService.getHymnViewMode(), hymnToView]);
          this.dialogRef.close(hymnToView);
          if(this.layoutService.singleView) {
            this.sidenavService.closeList();
          }
        });
      } else {
        if(this.hymnSelectionService.selectedHymn.hymnNumber === 34 && this.hymnNumber === '918') {
          // Enable the Debugger Console
          this.settingService.debuggerConsole = !this.settingService.debuggerConsole;
        } else {
          this.snackBar.open(translation.hymn_number_too_large, '✕', {
            duration: 2000,
          });
        }
      }
    }
  }

  dial(key: string) {
    this.zone.run(() => {
      this.hymnNumber = this.hymnNumber.substring(1) + key;
    });
  }

  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    event.preventDefault();
    this.zone.run(() => {
      switch (event.key) {
        case 'Enter':
          this.onHymn();
          break;
        default:
          if (!isNaN(+event.key)) {
            this.dial(event.key);
          }
      }
    });
  }
}
